import EditResearcherDialog from './EditResearcherDialog';

export default EditResearcherDialog;